import { render, staticRenderFns } from "./myTopic.vue?vue&type=template&id=c89dd32a&scoped=true"
import script from "./myTopic.vue?vue&type=script&lang=js"
export * from "./myTopic.vue?vue&type=script&lang=js"
import style0 from "./myTopic.vue?vue&type=style&index=0&id=c89dd32a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89dd32a",
  null
  
)

export default component.exports